import React from 'react'
import { Card, CardBody, Button } from 'reactstrap'
import { Show } from './uboManager'

export const UBOIntro = ({ setShow }: { setShow: (show: Show) => void }): React.ReactElement => {
  return (
    <Card>
      <CardBody>
        <h4>{"Let's identify who owns or controls this business"}</h4>
        <div className="mb-3">
          {
            'We’re required to collect information on individuals who directly or indirectly own 25% or more of this business. If another company owns shares, we’ll ask who owns that company.'
          }
        </div>
        <Button type="button" color="primary" className="btn-rotessa-primary" onClick={() => setShow(Show.FORM)}>
          Add Controlling Shareholders
        </Button>
      </CardBody>
    </Card>
  )
}
